import { useState } from "react";
import { useCustomer } from "hooks/useStore";
import useToggle from "hooks/useToggle";

const useSignupWithTags = ({ initialState, tags, track, scrollTop }) => {
	const { registerCustomerWithTags } = useCustomer(["registerCustomerWithTags"]);
	const [formState, setFormState] = useState(initialState);
	const [errors, setErrors] = useState({});
	const [loading, toggleLoading] = useToggle();
	const [success, setSuccess] = useState(false);

	const formSubmit = async (e) => {
		e.preventDefault();
		if (errors?.phoneNumber) return;

		toggleLoading();

		const { company, companyAddress, jobTitle, phoneNumber, companySize, role, additionalInfo, ...restFormState } = formState;
		const note = [
			phoneNumber ? `Phone Number: ${phoneNumber}` : "",
			company ? `Company: ${company}` : "",
			companyAddress ? `Company Address: ${companyAddress}` : "",
			jobTitle ? `Job Title: ${jobTitle}` : "",
			companySize ? `Company Size: ${companySize}` : "",
			role ? `Role: ${role}` : "",
			additionalInfo ? `Additional Info: ${additionalInfo}` : ""
		].filter(Boolean).join("\n");

		const response = await registerCustomerWithTags(restFormState, { note, tags });

		if (response.success) {
			setSuccess(true);
			track && track();
			scrollTop && window.scrollTo({ top: 0, behavior: "smooth" });
		}

		if (response.formError || response.companyFormError || !response.success) {
			setErrors({ form: response.message });
		} else if (response.fieldErrors || response.companyFieldErrors) {
			const mapErrors = response.customerUserErrors?.reduce((acc, error) => {
				acc[error.field[1]] = error.message;
				return acc;
			}, {});
			setErrors(mapErrors);
		}

		toggleLoading();

		return !!response.success;
	};

	const resetForm = () => {
		setSuccess(false);
		setFormState(initialState);
	};

	return {
		formState,
		setFormState,
		errors,
		setErrors,
		loading,
		formSubmit,
		success,
		resetForm
	};
};

export default useSignupWithTags;
